<template>
<div id="downloads" class="loginbg">
    <v-content>
        <v-layout>
            <v-flex xs12>
                <a href="https://loadmax.com" > <img src="/static/loadmaxlogo.png" alt="LoadMax" height="40" class="lgImg"></a>
            </v-flex>
        </v-layout>
        <v-container fluid fill-height class="">
            <!--<v-layout align-center justify-center>
                <v-flex xs12 sm8 md3 lg3>
                    <v-card class="elevation-1 pa-3">
                        <v-card-text>
                            <div class="layout column ">
                                <h1 class="flex">Downloads</h1>

                            </div>
                            <v-layout>
                                <v-flex md6 v-for="item in downloadObj" v-bind:key="item.id">
                                    <h1 @click="downLoad(item)" class="flex">{{item.doc_name}}</h1>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>-->
            <v-layout row>
                <v-flex xs12 sm6 offset-sm3>
                <v-card>
                    <v-toolbar color="orange" dark>
                    <v-toolbar-title>Downloads</v-toolbar-title>
                    </v-toolbar>

                    <v-list two-line subheader>
                        <v-list-tile
                                avatar
                                @click=""
                            >
                            <!--<v-list-tile-avatar>
                            <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                            </v-list-tile-avatar>-->

                            <v-list-tile-content v-if="downloadObj['file_type'] == 'folder'">
                                <v-list-tile-title>{{ downloadObj['folder_name'] }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-content v-else>
                                <v-list-tile-title>{{ downloadObj['doc_name'] }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ downloadObj['file_name'] }}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action @click="downLoad(downloadObj)">
                                <div>
                                <span class="downLoad-text">Downloading...</span>
                                <v-progress-circular indeterminate color="orange"></v-progress-circular>
                                </div>
                                <!--<v-btn icon ripple>
                                    <v-icon color="grey lighten-1" large>fa-arrow-circle-o-down</v-icon>
                                </v-btn>-->
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import services from "../../services/HttpService";
import utils from "../../util/";
import moment from 'moment';
import config from '../../config';
import axios from "axios";
import { setTimeout } from 'timers';
import SimpleCrypto from "simple-crypto-js";
var JSZip = require("jszip");
export default {
    data() {
        return {
            downloadObj: {},
            downloadLoaderObj: {}
        }
    },
    created() {
        const self = this,
        wApp = window.getApp;
        self.utils = utils;

        let downloadScript = document.createElement('script');
        downloadScript.setAttribute('type', 'text/javascript');
        downloadScript.setAttribute('src', '/static/js/download.js');
        document.head.appendChild(downloadScript); 
        
        if(typeof self.$route.query.items != 'undefined'){

            let _secretKey = config.secretKeyForIncryption;
            let simpleCrypto = new SimpleCrypto(_secretKey);
            let tempStr = decodeURI(self.$route.query.items)
            let decrypted = simpleCrypto.decrypt(tempStr.toString());
            self.downLoad(JSON.parse(decrypted))

        } else {
            axios.all([
                services.get("documents/download-document?token="+self.$route.query.token, {})
            ])
            .then(axios.spread(function (documents) {
                wApp.$emit("showLoader", {
                    show: false
                });
                if(documents.data.data){
                    // self.downloadObj = Object.assign({}, documents.data.data);
                    self.downLoad(documents.data.data)
                }
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
        }
    },
    mounted() {
        const self = this,
        wApp = window.getApp;        
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        async downLoad(docObj) {
            const self = this,
                wApp = window.getApp;

            // self.downloadLoaderObj[docObj.uuid] = false;

            if(docObj[0].file_type == "folder"){
                let qString = '?uuid='+docObj[0].doc_uuid+'&user_uuid='+docObj[0].user_uuid+'&is_public='+true;
                await services.get("documents/list-public"+qString
                // , {
                //     'Authorization': 'Bearer ' + this.$store.state.user.token
                // }
                )
                .then(async function (documents) {
                    let documentsForFolder = [];
                    if(documents.data.data && documents.data.data.otherDocs && documents.data.data.otherDocs.length > 0){
                        documentsForFolder = documents.data.data.otherDocs;

                    } else if(documents.data.data && documents.data.data.bussinessDocs && documents.data.data.bussinessDocs.length > 0){
                        
                        documentsForFolder = documents.data.data.bussinessDocs;
                    }
                    if(documentsForFolder){
                        let returnData = new Array();
                        var zip = new JSZip();
                        axios.all(
                            await documentsForFolder.map(async function(document){
                                await services.post("documents/public-download",
                                    {doc_path:document.doc_url}
                                    // ,{"Authorization": "Bearer " + self.$store.state.user.token}
                                    )
                                .then(async res => {
                                    if (res.status === 200) {
                                        await zip.file(document.file_name,res.data.documentEncrypted,{base64: true});
                                    }
                                })
                            })
                        ).then(axios.spread(function(response){
                            zip.generateAsync({type:"base64"}).then(async function(content) {
                                await download('data:application/zip;base64,'+content,docObj[0].folder_name+'.zip');                                  
                            });
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            setTimeout(()=>{
                                window.location.replace(config.thankYouPageUrl);
                            },1000);
                        }));
                    }else{
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(documents.data.message, config.errMsgColorStr);
                    }
                })
                .catch(function (err) {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                });
            } else if(docObj.length > 1){

                if(docObj){
                    let returnData = new Array();
                    var zip = new JSZip();
                    axios.all(
                        await docObj.map(async function(document){
                            await services.post("documents/public-download",
                                {doc_path:document.doc_url}
                                // ,{"Authorization": "Bearer " + self.$store.state.user.token}
                                )
                            .then(async res => {
                                if (res.status === 200) {
                                    await zip.file(document.file_name,res.data.documentEncrypted,{base64: true});
                                }
                            })
                        })
                    ).then(axios.spread(function(response){
                        zip.generateAsync({type:"base64"}).then(async function(content) {
                            await download('data:application/zip;base64,'+content,'downloads.zip');                                  
                        });
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        setTimeout(()=>{
                            window.location.replace(config.thankYouPageUrl);
                        },1000);
                    }));
                }else{
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(documents.data.message, config.errMsgColorStr);
                }

            } else {
                services.post("documents/public-download",
                    {doc_path:docObj[0].doc_url})
                .then(async res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (res.status === 200) {
                        await download('data:application/octet-stream;base64,'+res.data.documentEncrypted,docObj[0].file_name);
                        setTimeout(()=>{
                            window.location.replace(config.thankYouPageUrl);
                        },1000);
                        self._showToast(res.data.message);
                    } else {
                        self._showToast(res.data.message, "red");
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, "red");
                });
            }
        }
    }
};
</script>

<style lang="css" scoped>
#downloads {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/documents/Download.vue